import { Link, useNavigate } from 'react-router-dom';

export default function PublicHeader({ minimal }) {
  const nav = useNavigate();
  return (
    <header
      style={{
        background: '#0D1B3E',
        padding: '0 24px',
        position: 'sticky',
        top: 0,
        zIndex: 50,
        boxShadow: '0 2px 12px rgba(0,0,0,.15)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, maxWidth: 1240, margin: '0 auto', height: 64 }}>
        <Link to="/" data-testid="brand-link" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ background: '#E63946', borderRadius: 8, padding: '6px 10px', fontSize: 18 }}>🚗</div>
          <span style={{ color: '#fff', fontWeight: 900, fontSize: 18, letterSpacing: '-.02em' }}>RENTCARSUS</span>
        </Link>
        {!minimal && (
          <>
            <span style={{ color: 'rgba(255,255,255,.3)' }}>|</span>
            <span style={{ color: 'rgba(255,255,255,.65)', fontSize: 13 }}>Texas Car Rentals</span>
          </>
        )}
        <div style={{ flex: 1 }} />
        <Link to="/" data-testid="nav-browse" style={{ color: 'rgba(255,255,255,.85)', fontSize: 14, fontWeight: 600, padding: '8px 14px' }}>
          Browse Fleet
        </Link>
        <button
          data-testid="nav-admin"
          onClick={() => nav('/admin')}
          style={{
            padding: '8px 18px',
            borderRadius: 10,
            border: '1.5px solid rgba(255,255,255,.25)',
            background: 'transparent',
            color: '#fff',
            fontWeight: 700,
            fontSize: 13,
            cursor: 'pointer',
          }}
        >
          Admin
        </button>
      </div>
    </header>
  );
}
